// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { error } from 'react-notification-system-redux'
import { loadingToggler } from 'redux/modules/loading'
import fetchAndScrubSinglePath from './fetchAndScrubSinglePath'

const getUpdatedBulkEditPathsDataByPathId = pathIds => (dispatch, getState) => (
  dispatch(loadingToggler(async () => {
    const { bulkEdit } = getState()

    const bulkEditPaths = bulkEdit.get('bulkEditPaths')
    const unitType = bulkEdit.get('unitType')

    try {
      // returns a Promise.all which
      // will either store a promise which should resolve to scrubbed, updated path data
      // or a copy of the existing path data (if it wasn't just updated)
      return Promise.all(
        bulkEditPaths.reduce((a, path, pathIndex) => {
          const pathId = path.get('pathId')

          return a.concat(
            pathIds.includes(pathId)
              ? fetchAndScrubSinglePath(pathId, pathIndex, unitType)
              : path.toJS()
          )
        }, [])
      )
    } catch (err) {
      console.warn(err)
      dispatch(error({
        action: {
          callback: () => window.location.reload(),
          label: 'Refresh page.',
        },
        autoDismiss: 0,
        dismissible: false,
        message: 'There was an error when updating Path data in the browser. Please refresh the page.',
        title: 'Error when updating stored Bulk Edit path data',
      }))

      // if it failed, return the previous paths so we can easily handle in any caller.
      return bulkEditPaths
    }
  }))
)

export default getUpdatedBulkEditPathsDataByPathId
